import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


import  store  from '../store/index'

// console.log(store.state)


Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}


  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: isLoggedIn,
  },
 
  {
    path: '/routerAdd',
    name: 'routerAdd',
    component: () => import('../views/auth/routerAdd.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/levelAuth',
    name: 'levelAuth',
    component: () => import('../views/auth/levelAuth.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterLevel',
    name: 'masterLevel',
    component: () => import('../views/dataMaster/masterLevel.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/registrasi',
    name: 'registrasi',
    component: () => import('../views/dataMaster/registrasi.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/auth/register.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/m_unit_kerja',
    name: 'm_unit_kerja',
    component: () => import('../views/dataMaster/m_unit_kerja.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/m_pasar',
    name: 'm_pasar',
    component: () => import('../views/dataMaster/m_pasar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/m_jenis_lapak',
    name: 'm_jenis_lapak',
    component: () => import('../views/dataMaster/m_jenis_lapak.vue'),
    beforeEnter: isLoggedIn,
  },




  {
    path: '/petaWilayah',
    name: 'petaWilayah',
    component: () => import('../views/petaWilayah/petaWilayah.vue'),
    beforeEnter: isLoggedIn,
  },



  {
    path: '/kk',
    name: 'kk',
    component: () => import('../views/penduduk/kk.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/penduduk',
    name: 'penduduk',
    component: () => import('../views/penduduk/penduduk.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/generateToken',
    name: 'generateToken',
    component: () => import('../views/token/generateToken.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/APIAksesInfo',
    name: 'APIAksesInfo',
    component: () => import('../views/token/APIAksesInfo.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/checkData',
    name: 'checkData',
    component: () => import('../views/checkData/checkData.vue'),
    beforeEnter: isLoggedIn,
  },



]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
